import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Avatar,
} from "@mui/material";

interface UpcomingBookingCardProps {
  petName: string;
  petInitial: string;
  petBreed: string;
  ownerName: string;
  dateRange: string;
  serviceType: string;
  price: number;
  onViewDetails: () => void;
  avatarColor?: string;
}

const UpcomingBookingCard: React.FC<UpcomingBookingCardProps> = ({
  petName,
  petInitial,
  petBreed,
  ownerName,
  dateRange,
  serviceType,
  price,
  onViewDetails,
  avatarColor = "#178B8E",
}) => {
  return (
    <Card
      sx={{
        mb: 2,
        borderLeft: "4px solid",
        borderLeftColor: "primary.main",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <Avatar
            sx={{
              width: 56,
              height: 56,
              backgroundColor: avatarColor,
              fontSize: "1.5rem",
              fontWeight: 600,
            }}
          >
            {petInitial}
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
              {petName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {petBreed} · {ownerName}
            </Typography>
          </Box>
          <Typography
            variant="h6"
            sx={{ color: "primary.main", fontWeight: 700 }}
          >
            ${price}
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {dateRange} · {serviceType}
        </Typography>

        <Button
          variant="contained"
          size="small"
          onClick={onViewDetails}
          sx={{
            backgroundColor: "primary.light",
            "&:hover": {
              backgroundColor: "primary.main",
            },
          }}
        >
          View Details
        </Button>
      </CardContent>
    </Card>
  );
};

export default UpcomingBookingCard;
